module.exports = __webpack_public_path__ + "static/media/sub-card-label-8.d0a4b525.svg";